import { z } from 'zod'

import RadioBase from '@/components/Form/Atoms/RadioBase'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: 'お支払い方法' })

export type PaymentMethodType = 'credit' | 'postpay' | 'amazonpay' | 'free'

export const paymentMethodDefaultValue: PaymentMethodType = 'amazonpay'

export const paymentMethodValues: Record<PaymentMethodType, string> = {
  credit: 'クレジットカード決済',
  postpay: 'コンビニ・銀行　後払い',
  amazonpay: 'Amazon Pay',
  free: '無料',
}
export const paymentMethodInputKey = InputKey('paymentMethod', formResolverUtils.enum(paymentMethodValues).schema)

export default function PaymentMethodInput() {
  return (
    <>
      <RadioBase
        name={paymentMethodInputKey.name}
        values={(Object.keys(paymentMethodValues) as PaymentMethodType[]).reduce((previousValue, currentValue) => {
          return {
            ...previousValue,
            ...(currentValue == 'free'
              ? {}
              : { [currentValue]: paymentMethodValues[currentValue] as PaymentMethodType }),
          }
        }, {})}
      />
    </>
  )
}
